export const modules = [
    {
        name: "Pattern Recognition, Neural Networks & Deep Learning",
        level: "Level 7",
        description:
            "Covers advanced pattern recognition techniques and deep learning architectures.",
    },
    {
        name: "Machine Learning",
        level: "Level 6",
        description:
            "Introduction to ML concepts, including supervised and unsupervised learning.",
    },
    {
        name: "Dissertation",
        level: "Level 6",
        description:
            "Independent research project. My topic was on LLMs and its applications in automated unit testing.",
    },
    {
        name: "Optimization Methods",
        level: "Level 6",
        description:
            "Mathematical methods for optimizing algorithms in AI applications.",
    },
    {
        name: "AI Reasoning & Decision-Making",
        level: "Level 6",
        description:
            "Covers search algorithms, heuristics, and logic-based decision making.",
    },
    {
        name: "Computational Models",
        level: "Level 6",
        description:
            "Explores mathematical models used in computational problem-solving.",
    },
    {
        name: "Introduction to Artificial Intelligence",
        level: "Level 5",
        description:
            "Fundamental AI principles and applications across various domains.",
    },
    {
        name: "Software Engineering Group Project",
        level: "Level 5",
        description:
            "Collaborative software development project with real-world applications.",
    },
    
    {
        name: "Introduction to Software-Engineering",
        level: "Level 4",
        description:
            "Software development principles, practices, and project management.",
    },
    {
        name: "Data Structures",
        level: "Level 4",
        description:
            "Fundamental data structures and algorithms for efficient programming.",
    },
    {
        name: "Practical Experiences of Programming",
        level: "Level 5",
        description:
            "Hands-on programming projects to develop practical coding skills.",
    },
    {
        name: "Database Systems",
        level: "Level 4",
        description:
            "Introduction to database design, implementation, and management.",
    },
    {
        name: "Programming Practices and Applications",
        level: "Level 4",
        description:
            "Practical programming skills and software development techniques.",
    },
    {
        name: "Computer Systems",
        level: "Level 4",
        description:
            "Fundamental computer architecture and operating systems concepts.",
    },
    {
        name: "Elementary Logic with Applications",
        level: "Level 4",
        description:
            "Introduction to formal logic and its applications in computer science.",
    },
    {
        name: "Foundations of Computing 1",
        level: "Level 4",
        description:
            "Introduction to computing principles and problem-solving techniques.",
    },
    {
        name: "Foundations of Computing 2",
        level: "Level 5",
        description:
            "Advanced computing concepts and algorithmic problem-solving strategies.",
    },
    {
        name: "Introduction to Robotics",
        level: "Level 5",
        description:
            "Basic robotics principles, programming, and applications.",

    },
    {
        name: "Operating Systems and Concurrency",
        level: "Level 5",
        description:
            "Operating system design, concurrency, and parallel computing concepts.",
    },
    {
        name: "Cryptography",
        level: "Level 6",
        description:
            "Principles of secure communication and cryptographic algorithms.",
    },
    {
        name: "Introduction to Professional Practice",
        level: "Level 4",
        description:
            "Ethical, legal, and professional issues in computing and IT.",
    },
];